import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-9">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">常见问题</h2>
          <p className="mt-2 text-sm text-foreground-500">你可能想了解的事情</p>
        </div>
        <div className="max-w-2xl mx-auto flex flex-col gap-3">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-lg border border-background-200/70 p-5"
            >
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2">
                {item.question}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}